import React, { Component } from "react";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import TransferQrService from "../../../../services/transferencias/TransferQrService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faQrcode} from "@fortawesome/free-solid-svg-icons";

import PagoDepositoExtraccionQrService from "../../../../services/operaciones-qr/PagoDepositoExtraccionQrService";

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export default class TransferenciaQrEnviarPaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getInitialState = () => ({
    mensaje: undefined,
  });

  componentDidMount() {
    this.verificaTienePin();
  }


  verificaTienePin() {
    AuthService.verificaTienePin().then((response) => {
      var data = JSON.stringify(response.data);
      var jData = JSON.parse(data);

      if (jData.codigo !== 0) {
        this.setState(
          {
            mensaje: jData.mensaje,
          },
          function () {
            this.mainDiv.style.display = "none";
          }
        );
      }
    });
  }

  // On file select (from the pop up)
  onFileChange = event => {
    this.controlArchivo(event.target.files[0]);
    event.target.value = null;
  };

  async controlArchivo(file) {
    if (file === null) {
      return
    }

    const result = await toBase64(file).catch(e => Error(e));
    if (result instanceof Error) {
      Popup.queue(this.notifiPopup("Error", "Error inesperado al leer el archivo QR"));
      return;
    }
    this.decodificarQR(result);
  }

  decodificarQR(base64) {
    trackPromise(
      PagoDepositoExtraccionQrService.getDecodificarQr(null, base64).then((response) => {
        var data = JSON.stringify(response.data);
        var resp = JSON.parse(data);

        if (resp !== null) {
          if (resp.header !== null) {
            if (resp.header.codRespuesta === "0") {
              if (resp.data !== null) {
                if (resp.data.codRespuesta === "0") {     
                  if (AuthService.getCISocio() === resp.data.docDestinatario) {
                    Popup.queue(
                      this.notifiPopup(
                        "Info",
                        "Para transferir entre sus cuentas, diríjase al menú de Transferencias a Cuentas Propias"
                      )
                    );
                  } else {
                    this.props.returnDataPaso1(resp.data);
                    this.nextStep.click();
                  }             
                } else {
                  Popup.queue(this.notifiPopup("Atención", resp.data.txtRespuesta));
                }
              } else {
                Popup.queue(this.notifiPopup("Atención", "No se encontraron datos del QR, intente más tarde."));
              }
            } else {
              Popup.queue(this.notifiPopup("Atención", "El código QR no le pertenece a Cabal"));
            }
          } else {
            Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado, favor intente más tarde."));
          }
        } else {
          Popup.queue(this.notifiPopup("Atención", "Ocurrió un error inesperado, favor intente más tarde."));
        }

      })
    )
  }

  render() {
    return (
     <div>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Leer código QR
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">
                        Datos de Transferencia
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">
                        Datos de Verificación
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {this.state.mensaje !== undefined && (
            <div className="row">
              <div className="col-md-6">
                <div className="callout callout-warning consideraciones">
                  <h5>Consideraciones</h5>
                  <p>{this.state.mensaje}</p>
                </div>
              </div>
            </div>
          )}

          <div ref={(div) => (this.mainDiv = div)}>
          <div className="card" style={{ padding:"2rem", paddingBottom:0}} >
            <div className="container">
           
              <div className="col-md-12 qrcodelign">
                    <div className="form-group">
                      <div className="input-group">
                          <div className="row">
                            <div className="col-md-6" style={{display:"grid", justifyContent:"center" }} ><FontAwesomeIcon icon={faQrcode} style={{fontSize:"70px"}} /> </div>
                            <div className="col-md-6"><input type="file" className="custom-file-input info-box" id="qr" accept="image/*" onChange={this.onFileChange} />
                          <label className="custom-file-qr" htmlFor="qr"></label></div>
                          </div>
                      </div>
                    </div>
              </div>
            
            </div>
            </div>
          </div>
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}
          ></button>
      
      </div>
    );
  }
}